/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector} from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import APP_STRING from "../constants/strings";
import Utility from "../utility/utility";
import { actionSuccess} from "../redux/actions/joinAction";

const Name = (props) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();

  const gameData = useSelector(
    (state) => state.joinReducer.data
  );

  const [isLoading, setLoading] = useState(false);
  const [name, setName] = useState("");

  useEffect(() => {
    Utility.isSignedIn(gameData).then((value) => {
      if (value) {
        navigate("/gameboard");
      }
    });
  }, [gameData]);


  useEffect(() => {
  async function init() {
  
  const socket = await  Utility.getConnectedSocket()
    socket.on(
      "server_game_join", (data) => {
        const dataParsed = JSON.parse(data)
        if(dataParsed.result.status_code == 200){
          dispatch(actionSuccess(dataParsed.result.data)) 
          onSuccess()
        }else{
          Utility.showToast("error", dataParsed.result.message);
        }
      }
    );
  }
  init();
    return () => {
      Utility.disconnectSocket()
    }
  },[]);

  const JoinGame =async(e,is_facilitator)=> {
    e.preventDefault();

    if (validateLoginFields()) {
      const socket = await  Utility.getConnectedSocket()
      socket.emit(
        "client_game_join",
        JSON.stringify({ room_id: state?.room_id, name: name ,is_facilitator:is_facilitator})
      );
     
    }
  }

  async function onSuccess() {
    navigate("/gameboard");
  }
  
  async function onError(response) {
    Utility.showToast("error", response?.message || "problem in game joining");
    setLoading(false);
  }

  const validateLoginFields = () => {
    var message = "";
    if (Utility.isEmpty(name)) {
      message = APP_STRING.ENTER_NAME;
    }
    if (message === "") {
      return true;
    }
    Utility.showToast("error", message);
    return false;
  };

  return (
    <>
      <div className="background">
        <div className="container">
          <div className="text-center margin-name-top">
            <h1 className="text-white font-room-section">Enter Your Name</h1>
          </div>
          <div className="text-center">
            <input
              type="text"
              name="fname"
              placeholder="Enter Your Name"
              className="border-name-input semi-bold"
              onChange={(name) => setName(name.target.value)}
            />
          </div>
          <div className="text-center join-top">
            <button
              onClick={(e) => JoinGame(e,0)}
              type="button"
              className="btn border-name-button semi-bold"
            >
              Join
            </button>
          </div>
          {/* <div className="text-center join-top">
            <button
              onClick={(e) => JoinGame(e,1)}
              type="button"
              className="btn border-name-button semi-bold"
            >
              Join As Facilitator
            </button>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default Name;
